import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePublicBookingApi } from '@/customer/hooks/use-api'
import { publicBookingContextQueryKey } from '@/customer/hooks/use-public-booking-context'

/**
 * Cancels the appointment associated with the signed-link token via
 * `POST /api/public/cancel`.
 *
 * On success, invalidates the booking context so a follow-up read
 * reflects the cancelled state.
 */
export function usePublicCancelAppointment(token: string | null) {
  const api = usePublicBookingApi(token)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => dataOrThrow(await api.post('/public/cancel')),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: publicBookingContextQueryKey(token) })
    },
  })
}
